<div class="ccsw-callback">
  <div class="ccsw-callback-card">
    <div class="ccsw-callback-icon" aria-hidden="true">
      <i class="fas" [class.fa-spinner]="procesando" [class.fa-spin]="procesando"
         [class.fa-circle-check]="exitoso && !procesando"
         [class.fa-circle-xmark]="!exitoso && !procesando"></i>
    </div>
    <h1>{{ exitoso ? 'Listo' : (procesando ? 'Procesando…' : 'Atención') }}</h1>
    <p>{{ mensaje }}</p>
    <button type="button" class="btn btn-primary" *ngIf="!procesando" (click)="cerrar()">Cerrar</button>
  </div>
</div>
